module.exports = __webpack_public_path__ + "img/diente83.a310c67b.png";